import { render, staticRenderFns } from "./PermissionDeniedView.vue?vue&type=template&id=dd49acc0&"
import script from "./PermissionDeniedView.vue?vue&type=script&lang=js&"
export * from "./PermissionDeniedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports